<template>
  <b-modal
    v-model="open"
    ref="shareEmailModal"
    hide-header
    hide-footer
    size="xl"
    class="share-email"
  >
    <b-tabs>
      <b-tab
        title="Request a Quote"
        v-if="sharingType === specialCases.sharingType.dealer"
      >
        <b-form @submit.prevent="handleEmailDealer">
          <div class="p-3">
            <b-form-group>
              <label>Door quantity:</label>
              <b-input name="quantity" v-model="quantity" type="number"
                min="1" value="1" required />
            </b-form-group>
            <b-form-group>
              <label>Your email:</label>
              <b-input name="from" type="email" v-model="from" required />
            </b-form-group>
            <b-form-group>
              <label>Your phone:</label>
              <b-input name="phone" type="tel" v-model="phone" required />
            </b-form-group>
            <b-form-group>
              <label>Your first name:</label>
              <b-input name="firstname" v-model="firstname" required />
            </b-form-group>
            <b-form-group>
              <label>Your last name:</label>
              <b-input name="lastname" v-model="lastname" required />
            </b-form-group>
            <b-form-group>
              <label>Your address:</label>
              <b-input name="address" v-model="address" required />
            </b-form-group>
            <b-form-group>
              <label>Your city:</label>
              <b-input name="city" v-model="city" required />
            </b-form-group>
            <b-form-group>
              <label>Your country:</label>
              <b-form-select
                required
                v-model="country"
                :options="countries"
              ></b-form-select>
            </b-form-group>
            <b-form-group>
              <label>Your
                {{ country === 'Canada' ? 'province' :
                country === 'United States' ? 'state' : 'state/province' }}:</label>
              <b-form-select
                v-model="state"
                :options="country === 'Canada' ? provinces :
                  country === 'United States' ? states : []"
                required
              >
                <span slot="no-options" @click="$refs.select.open = false">
                  Select a country to view options
                </span>
              </b-form-select>
            </b-form-group>
            <b-form-group>
              <label>Your
                {{ country === 'Canada' ? 'Postal Code' :
                country === 'United States' ? 'ZIP' : 'ZIP/Postal Code' }}:</label>
              <b-input name="zip" v-model="zip" required />
            </b-form-group>
          </div>
          <footer class="modal-footer d-flex justify-content-between">
            <b-btn @click.prevent="open = false">Cancel</b-btn>
            <SpinnerButton
              type="submit"
              variant="primary"
              :disabled="isSendingEmail"
              :loading="isSendingEmail"
            >
              Send
            </SpinnerButton>
          </footer>
        </b-form>
      </b-tab>
      <b-tab
        title="Email a Friend"
        v-if="sharingType === specialCases.sharingType.friend"
      >
        <b-form @submit.prevent="handleEmailFriend">
          <div class="p-3">
            <b-form-group>
              <label>Their email:</label>
              <b-input name="to" type="email" v-model="to" required />
            </b-form-group>
            <b-form-group>
              <label>Your email:</label>
              <b-input name="from" type="email" v-model="from" required />
            </b-form-group>
            <b-form-group>
              <label>Your name:</label>
              <b-input name="name" v-model="name" required />
            </b-form-group>
          </div>

          <footer class="modal-footer d-flex justify-content-between">
            <b-btn @click.prevent="open = false">Cancel</b-btn>
            <SpinnerButton
              type="submit"
              variant="primary"
              :disabled="isSendingEmail"
              :loading="isSendingEmail"
            >
              Send
            </SpinnerButton>
          </footer>
        </b-form>
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import DealerLocator from '@/components/share/DealerLocator';
import Spinner from '@/components/utility/Spinner';
import SpinnerButton from '@/components/utility/SpinnerButton';
import { isSizeStep, getSelectedStepItem, isStepOfType } from '@/helpers/step';

export default {
  name: 'share-email',
  watch: {
    country(value) {
      if (!value) {
        this.state = undefined;
        this.zip = undefined;
      }
    },
  },
  data() {
    return {
      dealer: undefined,
      quantity: undefined,
      to: undefined,
      from: undefined,
      phone: undefined,
      firstname: undefined,
      lastname: undefined,
      country: 'United States',
      address: undefined,
      city: undefined,
      state: undefined,
      zip: undefined,
      isSendingEmail: false,
      countries: [
        { value: 'United States', text: 'United States' },
        { value: 'Canada', text: 'Canada' },
      ],
      provinces: [
        { text: 'Alberta', value: 'AB' },
        { text: 'British Columbia', value: 'BC' },
        { text: 'Manitoba', value: 'MB' },
        { text: 'New Brunswick', value: 'NB' },
        { text: 'Newfoundland and Labrador', value: 'NL' },
        { text: 'Northwest Territories', value: 'NT' },
        { text: 'Nova Scotia', value: 'NS' },
        { text: 'Nunavut', value: 'NU' },
        { text: 'Ontario', value: 'ON' },
        { text: 'Prince Edward Island', value: 'PE' },
        { text: 'Quebec', value: 'QC' },
        { text: 'Saskatchewan', value: 'SK' },
        { text: 'Yukon', value: 'YT' },
      ],
      states: [
        { text: 'Alabama', value: 'AL' },
        { text: 'Alaska', value: 'AK' },
        { text: 'American Samoa', value: 'AS' },
        { text: 'Arizona', value: 'AZ' },
        { text: 'Arkansas', value: 'AR' },
        { text: 'California', value: 'CA' },
        { text: 'Colorado', value: 'CO' },
        { text: 'Connecticut', value: 'CT' },
        { text: 'Delaware', value: 'DE' },
        { text: 'District of Columbia', value: 'DC' },
        { text: 'Federated States of Micronesia', value: 'FM' },
        { text: 'Florida', value: 'FL' },
        { text: 'Georgia', value: 'GA' },
        { text: 'Guam', value: 'GU' },
        { text: 'Hawaii', value: 'HI' },
        { text: 'Idaho', value: 'ID' },
        { text: 'Illinois', value: 'IL' },
        { text: 'Indiana', value: 'IN' },
        { text: 'Iowa', value: 'IA' },
        { text: 'Kansas', value: 'KS' },
        { text: 'Kentucky', value: 'KY' },
        { text: 'Louisiana', value: 'LA' },
        { text: 'Maine', value: 'ME' },
        { text: 'Marshall Islands', value: 'MH' },
        { text: 'Maryland', value: 'MD' },
        { text: 'Massachusetts', value: 'MA' },
        { text: 'Michigan', value: 'MI' },
        { text: 'Minnesota', value: 'MN' },
        { text: 'Mississippi', value: 'MS' },
        { text: 'Missouri', value: 'MO' },
        { text: 'Montana', value: 'MT' },
        { text: 'Nebraska', value: 'NE' },
        { text: 'Nevada', value: 'NV' },
        { text: 'New Hampshire', value: 'NH' },
        { text: 'New Jersey', value: 'NJ' },
        { text: 'New Mexico', value: 'NM' },
        { text: 'New York', value: 'NY' },
        { text: 'North Carolina', value: 'NC' },
        { text: 'North Dakota', value: 'ND' },
        { text: 'Northern Mariana Islands', value: 'MP' },
        { text: 'Ohio', value: 'OH' },
        { text: 'Oklahoma', value: 'OK' },
        { text: 'Oregon', value: 'OR' },
        { text: 'Palau', value: 'PW' },
        { text: 'Pennsylvania', value: 'PA' },
        { text: 'Puerto Rico', value: 'PR' },
        { text: 'Rhode Island', value: 'RI' },
        { text: 'South Carolina', value: 'SC' },
        { text: 'South Dakota', value: 'SD' },
        { text: 'Tennessee', value: 'TN' },
        { text: 'Texas', value: 'TX' },
        { text: 'Utah', value: 'UT' },
        { text: 'Vermont', value: 'VT' },
        { text: 'Virgin Islands', value: 'VI' },
        { text: 'Virginia', value: 'VA' },
        { text: 'Washington', value: 'WA' },
        { text: 'West Virginia', value: 'WV' },
        { text: 'Wisconsin', value: 'WI' },
        { text: 'Wyoming', value: 'WY' },
      ],
    };
  },
  computed: {
    ...mapState([
      'designUrl',
      'sharingEmail',
      'sharingType',
      'specialCases',
      'dealerID',
      'dealerEmail',
      'dealers',
      'currentProduct',
      'currentLayer',
    ]),
    open: {
      get() {
        return this.sharingEmail;
      },
      set(v) {
        this.setSharingEmail(v);
      },
    },
    currentLayerSize() {
      if (this.currentLayer) {
        const sizeStep = this.currentLayer.steps
          .find(step => isSizeStep(step, this.specialCases));
        return getSelectedStepItem(sizeStep);
      }
      return '';
    },
    currentLayerColor() {
      if (this.currentLayer) {
        const colorStep = this.currentLayer.steps
          .find(step => isStepOfType(step, this.specialCases, 'color'));
        return getSelectedStepItem(colorStep);
      }
      return '';
    },
  },
  methods: {
    ...mapMutations([
      'setSharingEmail',
    ]),
    ...mapActions([
      'getDealers',
    ]),
    handleDealerSelected(dealer) {
      this.dealer = dealer;
    },
    handleEmailDealer() {
      this.sendLead();
    },
    handleEmailFriend() {
      this.sendEmail(this.to, this.from, false);
    },
    async sendLead() {
      try {
        this.isSendingEmail = true;
        const chiData = window.Renoworks.CHIData;
        const url = `${window.Renoworks.Util.getBaseApiUrl()}/CHILead`;

        const layer = this.currentLayer;
        const width = layer.physicalWidth;
        const height = layer.physicalHeight;
        const { code } = this.$route.query;

        // Get selected Color
        const productSteps = this.currentProduct.getSteps();
        const colorStep = productSteps.find(step => step.name === 'Color');
        let colorCategory = colorStep.sections[0].categories.find(
          item => item.selected);
        if (!colorCategory) {
          colorCategory = colorStep.sections[0].categories[0];
        }
        // Required: Solid Color, Accents Woodtones, Morton Powder Coat, RAL Powder Coat, etc.
        let selectedColorCategoryName = null;
        // Required
        let selectedColorName = null;
        // Required if user choose RAL category else null
        let selectedRalColorCategory = null;
        // Required in all the cases but value will be 0 for RAL, Morton, CHI powder coats
        let colorID = 0;
        // Required in all the cases
        const orderModeEnum = 10;
        const orderSourceEnum = 2;
        // Conditional: The omerware code provided by CHI, the OwCode from the Color object
        let outsideColorOmerWareCode = null;
        // Conditional: Available only when AccentWoodTones else 0
        let frontAccentImageId = 0;
        // Conditional: Available only when RAL color
        let frontRALColorNumber = null;
        // Conditional: Available only when Morton color else 0
        let frontMortonColorId = 0;
        // Conditional: Available only when Powder Coat color
        let isOutsideColorStandardPowderCoat = null;
        // Conditional: Available only when Morton color
        let isOutsideColorCustomPowderCoat = null;
        // Conditional: Available only when Morton color
        let outsideColorCodeName = null;

        if (colorCategory) {
          selectedColorCategoryName = colorCategory.name;
          let selectedColorObj = colorCategory.items.find(
            item => item.selected);
          if (!selectedColorObj) {
            selectedColorObj = colorCategory.items[0];
          }
          selectedColorName = selectedColorObj.name;
          if (selectedColorObj.subOptions && selectedColorObj.subOptions.length) {
            selectedRalColorCategory = selectedColorObj.subOptions[0].name;
          }

          // Get color ID
          const colorOptions = chiData.getProductModel().colorOptions;

          let selectedColor = null;
          selectedColor = colorOptions.standardFrontColorOptions.find(
            item => item.displayName.toLowerCase() === selectedColorName.toLowerCase());
          if (selectedColor) {
            colorID = selectedColor.id;
          }
          if (!selectedColor) {
            selectedColor = colorOptions.chiPowderCoatOptions.find(
              (item) => {
                if (item.displayName) {
                  return item.displayName.toLowerCase() === selectedColorName.toLowerCase();
                }
                return item.name.toLowerCase() === selectedColorName.toLowerCase();
              });
            if (selectedColor) {
              colorID = 0;
              isOutsideColorStandardPowderCoat = true;
              outsideColorOmerWareCode = selectedColor.owCode;
            }
          }
          if (!selectedColor) {
            selectedColor = colorOptions.woodgrainPowderCoatOptions.find(
              item => item.displayName.toLowerCase() === selectedColorName.toLowerCase());
            if (selectedColor) {
              colorID = selectedColor.id;
              isOutsideColorStandardPowderCoat = false;
              outsideColorOmerWareCode = selectedColor.owCode;
            }
          }
          if (!selectedColor) {
            selectedColor = colorOptions.accentFrontColorOptions.find(
              item => item.displayName.toLowerCase() === selectedColorName.toLowerCase());
            if (selectedColor) {
              frontAccentImageId = selectedColor.imageNumber;
              colorID = selectedColor.id;
            }
          }
          if (!selectedColor) {
            selectedColor = colorOptions.ralColorOptions.find(
              item => item.displayName === selectedColorName);
            if (selectedColor) {
              frontRALColorNumber = selectedColor.displayName;
              isOutsideColorStandardPowderCoat = false;
              isOutsideColorCustomPowderCoat = true;
              outsideColorOmerWareCode = 15;
            }
          }
          if (!selectedColor) {
            selectedColor = colorOptions.mortonColorOptions.find(
              item => item.displayName === selectedColorName);
            if (selectedColor) {
              frontMortonColorId = selectedColor.id;
              isOutsideColorStandardPowderCoat = false;
              isOutsideColorCustomPowderCoat = true;
              outsideColorOmerWareCode = 1000;
              outsideColorCodeName = 'MOR';
            }
          }
          if (!selectedColor) {
            selectedColor = colorOptions.customFrontColorOptions.find(
              item => item.displayName === selectedColorName);
            if (selectedColor) {
              colorID = selectedColor.id;
            }
          }
        }

        let request = {
          ...chiData.getSummary(width * 12),
          dealerNumber: code,
          selectedOutsideColorCategory: selectedColorCategoryName,
          selectedOutsideColorName: selectedColorName,
          selectedOutsideRalColorCategory: selectedRalColorCategory,
          outsideColorId: colorID,
          frontMortonColorId,
          frontRALColorNumber,
          frontAccentImageId,
          isOutsideColorStandardPowderCoat,
          isOutsideColorCustomPowderCoat,
          outsideColorOmerWareCode,
          outsideColorCodeName,
          quantity: this.quantity,
          orderModeEnum,
          orderSourceEnum,
          dealerCustomer: {
            email: this.from,
            phone: this.phone,
            firstName: this.firstname,
            lastName: this.lastname,
            address1: this.address,
            city: this.city,
            state: this.state,
            zip: this.zip,
          },
          doorHeightWidth: {
            heightFeet: height ? Math.floor(height) : undefined,
            heightInch: height ? Math.round((height - Math.floor(height)) * 12) : undefined,
            widthFeet: width ? Math.floor(width) : undefined,
            widthInch: width ? Math.round((width - Math.floor(width)) * 12) : undefined,
          },
        };
        const removeEmpty = (obj) => {
          Object.keys(obj).forEach(k => (obj[k] === null && obj[k] !== undefined) && delete obj[k]);
          return obj;
        };

        request = removeEmpty(request);

        const response = await fetch(url, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(request),
        });
        const content = await response.text();

        let errorMessage = null;
        let message = 'Thank you for your interest in C.H.I. garage doors. We are working on your request, and we will be in touch soon!';
        let messageTitle = 'Your request has been sent';
        if (content && content.substring(0, 3) === '200') {
          const responseJSON = JSON.parse(content.substring(4));
          if (responseJSON && responseJSON.statusCode !== '200') {
            errorMessage = 'Failed to send quote. An error occurred.';
            if (responseJSON.errors && responseJSON.errors.length) {
              errorMessage = responseJSON.errors.join(' ');
            }
            messageTitle = 'Error!';
          }
        }
        this.$refs.shareEmailModal.hide();
        if (errorMessage) {
          message = errorMessage;
        }
        this.$root.alert(
          message,
          messageTitle,
        );
      } catch (err) {
        console.error(err); // eslint-disable-line no-console
      } finally {
        this.isSendingEmail = false;
      }
    },
    async sendEmail(toEmail, fromEmail = undefined, isDealer = false, dealerCode = undefined) {
      try {
        this.isSendingEmail = true;
        const emailUrl = `${window.Renoworks.Util.getBaseApiUrl()}/Email`;

        const request = {
          fromEmail,
          toEmail,
          isDealer,
          dealerCode,
          phone: this.phone,
          author: this.name,
          address: this.address,
          city: this.city,
          state: this.state,
          zip: this.zip,
          url: this.designUrl,
          product: this.currentProduct ? this.currentProduct.name : '',
          size: this.currentLayerSize ? this.currentLayerSize.name : '',
          color: this.currentLayerColor ? this.currentLayerColor.name : '',
        };

        const { success } = await window.jQuery.post(emailUrl, request).promise();

        if (success) {
          this.$refs.shareEmailModal.hide();
          if (isDealer) {
            this.$root.alert(
              'Thank you for submitting your request. We will get back to you as soon as possible.', 'Email a Dealer',
            );
          }
        } else {
          throw new Error('Failed to send email');
        }
      } catch (err) {
        console.error(err); // eslint-disable-line no-console
      } finally {
        this.isSendingEmail = false;
      }
    },
  },
  async created() {
    if (this.dealerID) {
      this.dealer = true; // show spinner
      await this.getDealers();
      this.dealer = this.dealers.find(({ id }) => String(id) === String(this.dealerID));
      if (!this.dealer) {
        throw new Error('invalid dealerID');
      }
    } else if (this.dealerEmail) {
      this.dealer = {}; // prevent showing dealer-locator
    }
  },
  components: {
    DealerLocator,
    Spinner,
    SpinnerButton,
  },
};
</script>

<style lang="scss">
@import "~@/assets/styles/variables.chi.scss";
@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/mixins";

.share-email {
  .modal-body {
    padding: 0;
  }

  .nav-tabs {
    background-color: $card-cap-bg;
    padding: ($spacer / 2) ($spacer * 3 / 4) 0;
  }

  .list-group-item {
    > label {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/share/Email.vue